export default __webpack_public_path__ + "static/media/p-plus-3.7426b56a.svg";